<template>
  <div class="preika-auth-page">
    <section class="preika-error-panel">
      <img
        src="/img/avatars/preika_black.png"
        alt="PREIKA"
        class="preika-error-panel__logo"
      >
      <span class="preika-error-panel__icon">
        <CIcon name="cil-warning"/>
      </span>
      <span class="preika-error-panel__code">500</span>
      <h1>一時的なエラーが発生しました</h1>
      <p>
        サーバーで処理を完了できませんでした。
        少し時間をおいて再度お試しいただくか、PREIKAサポート窓口へご連絡ください。
      </p>
      <div class="preika-error-panel__actions">
        <button type="button" class="btn btn-primary" @click="reloadPage">
          もう一度試す
        </button>
        <router-link to="/dashboard" class="btn btn-secondary">
          ダッシュボードへ
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Page500',

  methods: {
    reloadPage () {
      window.location.reload()
    }
  }
}
</script>

<style scoped>
.preika-error-panel {
  position: relative;
  z-index: 1;
  width: min(100%, 620px);
  padding: 52px;
  border: 1px solid rgba(255, 255, 255, .85);
  border-radius: 25px;
  background: rgba(255, 255, 255, .95);
  box-shadow: 0 30px 80px rgba(7, 52, 87, .17);
  text-align: center;
}

.preika-error-panel__logo {
  width: 150px;
  max-height: 48px;
  margin-bottom: 25px;
  object-fit: contain;
}

.preika-error-panel__icon {
  display: inline-flex;
  width: 66px;
  height: 66px;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  border-radius: 22px;
  background: var(--preika-warning-100);
  color: var(--preika-warning-600);
  font-size: 31px;
}

.preika-error-panel__code {
  display: block;
  color: var(--preika-warning-700);
  font-size: 38px;
  font-weight: 800;
  line-height: 1;
}

.preika-error-panel h1 {
  margin: 15px 0 12px;
  color: var(--preika-navy-900);
  font-size: 24px;
}

.preika-error-panel p {
  max-width: 470px;
  margin: 0 auto;
  color: var(--preika-text-muted);
  font-size: 12px;
  line-height: 1.9;
}

.preika-error-panel__actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 10px;
  margin-top: 28px;
}

@media (max-width: 575.98px) {
  .preika-error-panel {
    padding: 38px 23px;
  }

  .preika-error-panel__actions {
    align-items: stretch;
    flex-direction: column;
  }
}
</style>
